import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Validators, FormGroup } from '@angular/forms';
import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,
  SECTION_CONTROL_ALIGNMENT,
  iceColumnDefinition
} from '../../../projects/icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../projects/icemedx-lib/src/services/iceutility';
import { AppService } from '../app.service';
import { IceNavService } from '../../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { DomainService } from '../../../projects/icemedx-lib/src/services/domain/domain.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { LoginService } from '../../../projects/icemedx-lib/src/login/login.service';
import { IBaseView } from '../../../projects/icemedx-lib/src/components/baseview.component';
import { IIceEntity } from '../../../projects/icemedx-lib/src/models/core/IceEntity';
import { telehealthtrial } from '../../../projects/icemedx-lib/src/models/landing/telehealthtrial';
import { registerforappointment } from '../../../projects/icemedx-lib/src/models/landing/registerforappointment';
import { registerforbenefits } from '../../../projects/icemedx-lib/src/models/landing/registerforbenefits';
import { country } from '../../../projects/icemedx-lib/src/models/common/country';

const CancelReport: string = "CancelReport";
const SaveReport: string = "SaveReport";
const Specialty: string = "Specialty";
const Title: string = "Title";
const FirstName: string = "Firstname";
const LastName: string = "Lastname";
const Credentials: string = "Credentials";
const Suffix: string = "Suffix";
const Email: string = "Email";
const Phone: string = "Phone";
const Country: string = "Country";
const PayPalSimple: string = "PayPalSimple";
const FreeTelehealthAnswer: string = "FreeTelehealthAnswer";
const ProfessionalBackgroundAnswer: string = "ProfessionalBackgroundAnswer";
const CampaignTelehealth: number = 1;
const CampaignRegisterForAppointment: number = 2;
const CampaignJoinOurProfessionalNetwork: number = 3;
const CampaignJoinOurPharmacyNetwork: number = 4;
const CampaignRegisterForBenefits: number = 40;
const CampaignRegisterToVoter: number = 20221;
const CampaignPayPalSimpleSubscribe: number = 2000;
const CampaignRegisterToNominate: number = 202207;

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit, IBaseView {

  landingSettings: IcepanelcontainerSettings = null;
  landingHeaderTitle: string = "";
  specialtyCtrl: IcecontrolSettings = null;
  titleCtrl: IcecontrolSettings = null;
  firstNameCtrl: IcecontrolSettings = null;
  lastNameCtrl: IcecontrolSettings = null;
  phoneCtrl: IcecontrolSettings = null;
  countryCtrl: IcecontrolSettings = null;
  emailCtrl: IcecontrolSettings = null;
  credentialCtrl: IcecontrolSettings = null;
  backgroundCtrl: IcecontrolSettings = null;
  payPalSimpleSubscribe: IcecontrolSettings = null;
  countryMap: { name: string, value: string }[] = [];

  campaignId: number = 0;
  campaigneAd: string = "";
  submissionObj: IIceEntity = null;

  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loginSvc: LoginService,
    private domainSvc: DomainService) {

    // Make sure to end session
    loginSvc.SessionLogout(true);

    this.activatedRoute.params.subscribe(next => {
      if (next != null && next.id != null) {
        this.campaignId = Iceutility.toLong(next.id);
        switch (this.campaignId) {
          case CampaignTelehealth:
          case CampaignJoinOurProfessionalNetwork: {
            if (CampaignJoinOurProfessionalNetwork == this.campaignId) {
              this.campaigneAd = "./assets/JoinOurProfessionalTeamNetwork.1.png";
              this.landingHeaderTitle = "Join our Network";
            }
            else {
              this.campaigneAd = "./assets/SocialDistance.1.png";
              this.landingHeaderTitle = "TeleHealth, 14-day Trial";
            }
            this.appSvc.addBreadcrumb("Free Registration", {}, true, "");
            let panelTag = "TeleHealth";
            let panelKey = Iceutility.guid(false);
            this.landingSettings = this.viewSetup(new telehealthtrial());

            break;
          }
          case CampaignRegisterForAppointment: {
            this.campaigneAd = "./assets/RegisterforContactlessHealthcare.1.png";
            this.landingHeaderTitle = "Register for Appointment";
            this.appSvc.addBreadcrumb("Free Registration", {}, true, "");
            let panelTag = "Appointment";
            let panelKey = Iceutility.guid(false);
            this.landingSettings = this.viewSetup(new registerforappointment());
            break;
          }
          case CampaignRegisterForBenefits:
          case CampaignRegisterToVoter:
          case CampaignRegisterToNominate: {
            this.campaigneAd = "./assets/JoinOurProfessionalTeamNetwork.1.png";
            if (loginSvc.whitelabel_brand != null && loginSvc.whitelabel_brand.length > 0) {
              this.campaigneAd = "./assets/landing_img_local2.png";              
            }

            this.landingHeaderTitle = "Request for Membership Application";
            let breadCrm = "Membership Registration";
            if (this.campaignId == CampaignRegisterToVoter) {
              this.landingHeaderTitle = "Request for Ballot";
              breadCrm = "Voter Registration";
            }
            else if (this.campaignId == CampaignRegisterToNominate) {
              this.landingHeaderTitle = "Request to Nominate Member";
              breadCrm = "Nomination Application Form";
            }
            this.appSvc.addBreadcrumb(breadCrm, {}, true, "");
            this.landingSettings = this.viewSetup(new registerforbenefits());
            break;
          }
          case CampaignJoinOurPharmacyNetwork:
            this.campaigneAd = "./assets/JoinOurProfessionalTeamNetwork.1.png";
            this.landingHeaderTitle = "Request for Membership Application";
            this.appSvc.addBreadcrumb("Membership Registration", {}, true, "");
            this.landingSettings = this.viewSetup(new registerforbenefits());
            break;
          case CampaignPayPalSimpleSubscribe: {
            this.campaigneAd = "./assets/JoinOurProfessionalTeamNetwork.1.png";
            if (loginSvc.whitelabel_brand != null && loginSvc.whitelabel_brand.length > 0) {
              this.campaigneAd = "./assets/landing_img_local2.png";
            }

            this.landingHeaderTitle = "EWF Annual Dues";
            let breadCrm = "Payment Link to PayPal";
            this.appSvc.addBreadcrumb(breadCrm, {}, true, "");
            this.landingSettings = this.viewSetup(new registerforbenefits());
            break;
          }
          default: {
            this.landingHeaderTitle = "";
            this.appSvc.addBreadcrumb("", {}, true, "");
            this.landingSettings = this.viewSetup(null);
            break;
          }
        }
      }
    });
    this.domainSvc.getCountries().subscribe((countries: country[]) => {
      this.countryMap = countries.map(c => {
        return { name: c.name, value: c.Iso2 };
      });

      this.countryCtrl.setOptions(this.countryMap);
    });
  }

  viewSetup(dat: IIceEntity): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      if (dat == null) {
        return null;
      }

      this.submissionObj = dat;

      switch (this.campaignId) {
        case CampaignTelehealth:
        case CampaignJoinOurProfessionalNetwork: {
          let tables: IcemattableSettings[] = [
          ];
          let groups: IcepanelgroupSettings[] = [
            new IcepanelgroupSettings(null, tables)
          ];

          let surveySections: IcepanelsectionSettings[] = [
          ];

          surveySections.push(this.professionalBackgroundOption());
          surveySections.push(this.memberDetails(Specialty));
          surveySections.push(this.memberDetails(Title));
          surveySections.push(this.memberDetails(FirstName));
          surveySections.push(this.memberDetails(LastName));
          surveySections.push(this.memberDetails(Credentials));
          surveySections.push(this.memberDetails(Email));
          surveySections.push(this.memberDetails(Phone));
          surveySections.push(this.memberDetails(Country));

          let headerControls = [
            new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, SaveReport),
            new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, CancelReport)
          ];

          let panels: IcepanelSettings[] = [
            new IcepanelSettings("TeleHealth", Iceutility.guid(false), this.landingHeaderTitle, "", surveySections, headerControls)
              .enableForm()
          ];

          let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
          setup = new IcepanelcontainerSettings("TeleHealthFreeTrial", panelrows);
          break;
        }
        case CampaignRegisterForAppointment: {
          let tables: IcemattableSettings[] = [
          ];
          let groups: IcepanelgroupSettings[] = [
            new IcepanelgroupSettings(null, tables)
          ];

          let surveySections: IcepanelsectionSettings[] = [
          ];

          surveySections.push(this.memberDetails(Title));
          surveySections.push(this.memberDetails(FirstName));
          surveySections.push(this.memberDetails(LastName));
          surveySections.push(this.memberDetails(Suffix));
          surveySections.push(this.memberDetails(Email));
          surveySections.push(this.memberDetails(Phone));
          surveySections.push(this.patientBackgroundOption());

          let headerControls = [
            new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, SaveReport),
            new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, CancelReport)
          ];

          let panels: IcepanelSettings[] = [
            new IcepanelSettings("Appointment", Iceutility.guid(false), this.landingHeaderTitle, "", surveySections, headerControls)
              .enableForm()
          ];

          let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
          setup = new IcepanelcontainerSettings("AppointmentFreeTrial", panelrows);
          break;
        }
        case CampaignRegisterForBenefits:
        case CampaignRegisterToVoter:
        case CampaignRegisterToNominate: {
          let tables: IcemattableSettings[] = [
          ];
          let groups: IcepanelgroupSettings[] = [
            new IcepanelgroupSettings(null, tables)
          ];

          let surveySections: IcepanelsectionSettings[] = [
          ];

          surveySections.push(this.memberDetails(Title));
          surveySections.push(this.memberDetails(FirstName));
          surveySections.push(this.memberDetails(LastName));
          surveySections.push(this.memberDetails(Suffix));
          surveySections.push(this.memberDetails(Email));
          surveySections.push(this.memberDetails(Phone));
          if (this.campaignId == CampaignRegisterForBenefits)
            surveySections.push(this.subscriberBackgroundOption());
          else if (this.campaignId == CampaignRegisterToVoter)
            surveySections.push(this.voterBackgroundOption());
          else 
            surveySections.push(this.nominateBackgroundOption());

          let headerControls = [
            new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, SaveReport),
            new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, CancelReport)
          ];

          let panels: IcepanelSettings[] = [
            new IcepanelSettings("Appointment", Iceutility.guid(false), this.landingHeaderTitle, "", surveySections, headerControls)
              .enableForm()
          ];

          let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
          setup = new IcepanelcontainerSettings("AppointmentFreeTrial", panelrows);
          break;
        }
        case CampaignPayPalSimpleSubscribe: {
            let tables: IcemattableSettings[] = [
            ];
            let groups: IcepanelgroupSettings[] = [
              new IcepanelgroupSettings(null, tables)
            ];

            let surveySections: IcepanelsectionSettings[] = [
            ];

          surveySections.push(this.memberDetails(PayPalSimple));

            let headerControls = [
              new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, SaveReport),
              new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, CancelReport)
            ];

            let panels: IcepanelSettings[] = [
              new IcepanelSettings("Appointment", Iceutility.guid(false), this.landingHeaderTitle, "", surveySections, headerControls)
                .enableForm()
            ];

            let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
            setup = new IcepanelcontainerSettings("AppointmentFreeTrial", panelrows);
            break;
          }
      }
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }
    

  trialOption(): IcepanelsectionSettings {
    let secSection: IcepanelsectionSettings = null; 
    try {
      let answers = [{ name: "Yes", value: "Y" }, { name: "No", value: "N" }];
      let controls: IcecontrolSettings[] = [
        new IcecontrolSettings("icelabel", { value: "Select 'Yes' to sign-up for the 14-day trial.", width: "200px", display: "inline", 'vertical-align': 'middle' }, null, null),
        new IcecontrolSettings("iceselect", { menuItems: answers, width: "50px" }, null, null, FreeTelehealthAnswer, "Answer")
          .setControlName(FreeTelehealthAnswer)
          .createFormControl("Y", [Validators.required]),
      ];

      secSection = new IcepanelsectionSettings("TrialSection", { class: ["yalla"], styles: { /*width: "100%"*/ } }, [], controls, null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignHorizontal)
        .setUseSpacing(false);
    }
    catch (e) {
      console.log(e);
    }
    return secSection;
  }

  professionalBackgroundOption(): IcepanelsectionSettings {
    let secSection: IcepanelsectionSettings = null;
    try {
      let answers = [{ name: "Doctor", value: "doctor" }, { name: "Hospital administrator", value: "administrator" }, { name: "Health IT", value: "IT" }];

      this.backgroundCtrl = new IcecontrolSettings("iceselect", { menuItems: answers, width: "100px", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ProfessionalBackgroundAnswer, "Answer")
        .setControlName(ProfessionalBackgroundAnswer)
        .createFormControl("doctor", [Validators.required]);

      let controls: IcecontrolSettings[] = [
        new IcecontrolSettings("icelabel", { value: "Describe your professional background?", width: "200px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null),
        this.backgroundCtrl
      ];

      secSection = new IcepanelsectionSettings("BackgroundSection", { class: ["yalla"], styles: { /*width: "100%"*/ } }, [], controls, null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignHorizontal)
        .setUseSpacing(false);
    }
    catch (e) {
      console.log(e);
    }
    return secSection;
  }

  patientBackgroundOption(): IcepanelsectionSettings {
    let secSection: IcepanelsectionSettings = null;
    try {
      let answers = [
        { name: "I would like a consultation", value: IceTypes.RegistrationTopics.rtConsult },
        { name: "I would like to schedule a follow-up appointment", value: IceTypes.RegistrationTopics.rtFollowup },
        { name: "Not feeling well", value: IceTypes.RegistrationTopics.rtSick },
        { name: "I am a pregnant patient", value: IceTypes.RegistrationTopics.rtPregnant },
        { name: "I am a cancer patient", value: IceTypes.RegistrationTopics.rtCancer },
        { name: "I am a diabetic patient", value: IceTypes.RegistrationTopics.rtDiabetic },
        { name: "I am a HIV patient", value: IceTypes.RegistrationTopics.rtHIV },
        { name: "I am a COVID-19 patient", value: IceTypes.RegistrationTopics.rtCOVID19 },
        { name: "I have multiple comorbidities or health problems", value: IceTypes.RegistrationTopics.rtMultiple },
      ];

      this.backgroundCtrl = new IcecontrolSettings("iceselect", { menuItems: answers, width: "300px", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ProfessionalBackgroundAnswer, "Answer")
        .setControlName(ProfessionalBackgroundAnswer)
        .createFormControl("consult", [Validators.required]);

      let controls: IcecontrolSettings[] = [
        new IcecontrolSettings("icelabel", { value: "Describe the purpose for a doctor's visit?", width: "200px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null),
        this.backgroundCtrl
      ];

      secSection = new IcepanelsectionSettings("BackgroundSection", { class: ["yalla"], styles: { /*width: "100%"*/ } }, [], controls, null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignHorizontal)
        .setUseSpacing(false);
    }
    catch (e) {
      console.log(e);
    }
    return secSection;
  }

  subscriberBackgroundOption(): IcepanelsectionSettings {
    let secSection: IcepanelsectionSettings = null;
    try {
      let answers = [
        { name: "I would like to subscribe to benefits", value: IceTypes.RegistrationTopics.rtSubscriber },
        { name: "I would like to manage my benefit subscription", value: IceTypes.RegistrationTopics.rtSubscriber },
        { name: "I would like to communicate with my benefits manager", value: IceTypes.RegistrationTopics.rtSubscriber },
      ];

      this.backgroundCtrl = new IcecontrolSettings("iceselect", { menuItems: answers, width: "300px", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ProfessionalBackgroundAnswer, "Answer")
        .setControlName(ProfessionalBackgroundAnswer)
        .createFormControl("consult", [Validators.required]);

      let controls: IcecontrolSettings[] = [
        new IcecontrolSettings("icelabel", { value: "Describe the purpose for registration?", width: "200px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null),
        this.backgroundCtrl
      ];

      secSection = new IcepanelsectionSettings("BackgroundSection", { class: ["yalla"], styles: { /*width: "100%"*/ } }, [], controls, null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignHorizontal)
        .setUseSpacing(false);
    }
    catch (e) {
      console.log(e);
    }
    return secSection;
  }

  voterBackgroundOption(): IcepanelsectionSettings {
    let secSection: IcepanelsectionSettings = null;
    try {
      let answers = [
        { name: "Local Two", value: IceTypes.RegistrationTopics.rtSubscriber },
      ];

      this.backgroundCtrl = new IcecontrolSettings("iceselect", { menuItems: answers, width: "300px", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ProfessionalBackgroundAnswer, "Answer")
        .setControlName(ProfessionalBackgroundAnswer)
        .createFormControl("consult", [Validators.required]);

      let controls: IcecontrolSettings[] = [
        new IcecontrolSettings("icelabel", { value: "Your Local?", width: "200px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null),
        this.backgroundCtrl
      ];

      secSection = new IcepanelsectionSettings("BackgroundSection", { class: ["yalla"], styles: { /*width: "100%"*/ } }, [], controls, null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignHorizontal)
        .setUseSpacing(false);
    }
    catch (e) {
      console.log(e);
    }
    return secSection;
  }

  nominateBackgroundOption(): IcepanelsectionSettings {
    let secSection: IcepanelsectionSettings = null;
    try {
      let answers = [
        { name: "Local 2", value: IceTypes.RegistrationTopics.rtSubscriber },
      ];

      this.backgroundCtrl = new IcecontrolSettings("iceselect", { menuItems: answers, width: "300px", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ProfessionalBackgroundAnswer, "Answer")
        .setControlName(ProfessionalBackgroundAnswer)
        .createFormControl("consult", [Validators.required]);

      let controls: IcecontrolSettings[] = [
        new IcecontrolSettings("icelabel", { value: "Your Local?", width: "200px", class: { "col-sm": true }, hasFullWidthContainer: false }, null, null),
        this.backgroundCtrl
      ];

      secSection = new IcepanelsectionSettings("BackgroundSection", { class: ["yalla"], styles: { /*width: "100%"*/ } }, [], controls, null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignHorizontal)
        .setUseSpacing(false);
    }
    catch (e) {
      console.log(e);
    }
    return secSection;
  }

  memberDetails(ctrlName: string): IcepanelsectionSettings {
    let secSection: IcepanelsectionSettings = null;
    try {
      let ctrl: IcecontrolSettings = null;
      switch (ctrlName) {
        case Specialty: {
          this.specialtyCtrl = ctrl = new IcecontrolSettings("iceinput", { width: "100%", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ctrlName, "Enter Your Specialty i.e. Oncology, OBGYN")
            .setControlName(ctrlName)
            .createFormControl("", [Validators.required]);
            break;
          }
        case Title: {
          this.titleCtrl = ctrl = new IcecontrolSettings("iceinput", { width: "100%", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ctrlName, "Title i.e. Mrs., Mr., Dr., Prof., etc. ")
            .setControlName(ctrlName)
            .createFormControl("", [Validators.required]);
          break;
        }
        case Credentials:
        case Suffix:
        {
            this.credentialCtrl = ctrl = new IcecontrolSettings("iceinput", { width: "100%", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ctrlName, ctrlName == Suffix ? "Suffix i.e. Jr., Sr., II, etc." : "Credentials i.e. MD, PhD., OFC, etc.")
            .setControlName(ctrlName)
              .createFormControl("", ctrlName == Suffix ? null : [Validators.required]);
          break;
        }
        case FirstName: {
          this.firstNameCtrl = ctrl = new IcecontrolSettings("iceinput", { width: "100%", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ctrlName, "First name")
            .setControlName(ctrlName)
            .createFormControl("", [Validators.required]);
          break;
        }
        case LastName: {
          this.lastNameCtrl = ctrl = new IcecontrolSettings("iceinput", { width: "100%", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ctrlName, "Last or surname")
            .setControlName(ctrlName)
            .createFormControl("", [Validators.required]);
          break;
        }
        case Email: {
          this.emailCtrl = ctrl = new IcecontrolSettings("iceinput", { width: "100%", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ctrlName, "Email address")
            .setControlName(ctrlName)
            .createFormControl("", [Validators.required]);
          break;
        }
        case Phone: {
          this.phoneCtrl = ctrl = new IcecontrolSettings("iceinput", { width: "100%", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ctrlName, "Phone contact")
            .setControlName(ctrlName)
            .createFormControl("", [Validators.required]);
          break;
        }
        case Country: {
          this.countryCtrl = ctrl = new IcecontrolSettings("iceselect", { width: "100%", menuItems: this.countryMap, class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ctrlName, "Country")
            .setControlName(ctrlName)
            .createFormControl("", [Validators.required]);
          break;
        }
        case PayPalSimple: {
          this.specialtyCtrl = ctrl = new IcecontrolSettings("icepaypalsimplesubscribe", { width: "100%", class: { "col-lg": true }, hasFullWidthContainer: false }, null, null, ctrlName, "Enter Your Specialty i.e. Oncology, OBGYN")
            .setControlName(ctrlName)
            .createFormControl("", [Validators.required]);
          break;
        }
      }

      if (ctrl) {
        let controls: IcecontrolSettings[] = [
          ctrl
        ];

        secSection = new IcepanelsectionSettings(ctrlName + "Section", { class: ["yalla"], styles: { width: "100%" } }, [], controls, null)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical)
          .setUseSpacing(false);
      }
    }
    catch (e) {
      console.log(e);
    }
    return secSection;
  }


  ngOnInit() {
    this.appSvc.refreshMenus();
    this.navSvc.hideSideMenu(true);
    this.navSvc.showTopMenuParent(this.navSvc.topMenuMessagesParentElementID, false);
  }

  public onHeaderActionClick(event) {
    if (event.headerCtrl && event.headerCtrl.id == CancelReport) {
      this.landingSettings = this.viewSetup(null);
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "Submission cancelled.");
      return;
    }

    if (event.headerCtrl instanceof IcepanelSettings) {
      let landingPanel: IcepanelSettings = event.headerCtrl;
      let landingForm: FormGroup = landingPanel.getForm();
      if (landingForm == null || false == landingForm.valid) {
        this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "Answer all required questions.");
        return;
      }

      if (this.submissionObj != null) {
        switch (this.campaignId) {
          case CampaignTelehealth:
          case CampaignJoinOurProfessionalNetwork:
          case CampaignRegisterForAppointment:
          case CampaignRegisterForBenefits:
          case CampaignRegisterToVoter:
          {
            let svy: telehealthtrial = <telehealthtrial>this.submissionObj;
            svy.Campaign = CampaignTelehealth == this.campaignId ? "Request to Setup my Practice/Department" : this.landingHeaderTitle;
            svy.Background = this.backgroundCtrl.getFormControl().value;
              if (this.specialtyCtrl != null)
              svy.Specialty = this.specialtyCtrl.getFormControl().value;
            svy.Title = this.titleCtrl.getFormControl().value;
            svy.Firstname = this.firstNameCtrl.getFormControl().value;
            svy.Lastname = this.lastNameCtrl.getFormControl().value;
            svy.Phone = this.phoneCtrl.getFormControl().value;
            svy.Email = this.emailCtrl.getFormControl().value;
            svy.Country = this.countryCtrl.getFormControl().value;
            svy.Credentials = this.credentialCtrl.getFormControl().value;

            let capAry = [];
            if (svy.Campaign != null) {
              capAry.push(svy.Campaign);
            }
            if (svy.Specialty != null) {
              capAry.push(svy.Specialty);
            }
            if (svy.Background != null) {
              capAry.push(svy.Background);
            }
            let caption = capAry.join(',');

            let callback = this.loginSvc.GetLoginUrl('code');
            this.loginSvc.doWLRegister(callback, caption, svy, false);
            break;
          }
        }
      }
    }
  }

}
